module.exports = __webpack_public_path__ + "static/img/6一种方便调整的弯管机.d1f06ef6.jpg";